import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-alert-messages',
  templateUrl: './alert-messages.component.html',
})
export class AlertMessagesComponent implements OnInit {
  typeMessage: string;
  icon: string;
  mensaje: string;
  constructor() {}

  ngOnInit() {}
}
